import {
  createSettingFieldView,
  PopupContext,
  PopupPipe,
  Workbench,
} from '@alilc/lowcode-editor-skeleton';

export default function getSkeletonCabin() {
  return {
    createSettingFieldView,
    PopupContext,
    PopupPipe,
    Workbench,
  };
}